var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.states)?_c('w-autocomplete',_vm._g(_vm._b({attrs:{"items":_vm.states,"name":"us-states-selector","placeholder":_vm.l.t('app.state', 'State'),"filter":_vm.filter_object,"hide-details":"auto","autocomplete":"new-password","data-test-id":"us-states-selector"}},'w-autocomplete',_vm.$attrs,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }